export function getPharmaColours() {
    const DISTINCT = [
      "#4e79a7", "#f28e2b", "#e15759", "#76b7b2", "#59a14f",
      "#edc948", "#b07aa1", "#ff9da7", "#9c755f", "#bab0ab"
    ];
    return DISTINCT;
  }
  
  export function getPharmaConfig() {
    const groupsById = {
  

      aware_340b: {
        type: "likert",
        label: "Awareness of the 340B program",
        fulltext: "How familiar are you with the federal 340B drug pricing program?",
        keys: [
        "aware_340b_yes_pred",
          "aware_340b_unsure_pred",
          "aware_340b_no_pred",
        ],
        labels: {
            "aware_340b_yes_pred": "Aware",
          "aware_340b_unsure_pred": "Unsure",
          "aware_340b_no_pred": "Not aware",
        },
        polarity: {

        pos: "aware_340b_yes_pred",
        neu: "aware_340b_unsure_pred",
        neg: "aware_340b_no_pred"
        },
      schema:"client"
      },

      support_340b: {
        type: "likert",
        label: "Support of the 340B program",
        fulltext: "How do you feel about the 340B Drug Pricing Program?",
        keys: [
          "support_340b_pred",
          "oppose_340b_pred",
          "neutral_340b_pred",
        ],
        labels: {
          "support_340b_pred": "Support",
          "oppose_340b_pred": "Oppose",
          "neutral_340b_pred": "Neutral",
        },
        polarity: {

        pos: "support_340b_pred",
        neu: "neutral_340b_pred",
        neg: "oppose_340b_pred"
        },
      schema:"client"
      },


  
      familiar_340b: {
        type: "categorical",
        label: "Familiarity with 340B",
        fulltext: "How would you describe your understanding of the 340B program?",
        keys: [
          "unaware_340b_pred",
          "somewhat_familiar_340b_pred",
          "understand_well_340b_pred",
          "nameOnly_340b_pred",
        ],
        labels: {
          "unaware_340b_pred": "Unaware",
          "somewhat_familiar_340b_pred": "Somewhat familiar",
          "understand_well_340b_pred": "Understand well",
          "nameOnly_340b_pred": "Recognize the name only",
        },
      schema:"client"
      },
  
      benefits_340b: {
        type: "categorical",
        label: "Who benefits most from 340B?",
        fulltext: "Who do you think benefits most from programs like 340B?",
        keys: [
          "benefits_hospitals_pred",
          "benefits_patients_pred",
          "benefits_pharma_pred",
        ],
        labels: {
          "benefits_hospitals_pred": "Hospitals",
          "benefits_patients_pred": "Patients",
          "benefits_pharma_pred": "Pharmaceutical companies",
        },
      schema:"client",
      },
  
  
      checkbox_against: {
        type: "categorical",
        label: "Messaging against 340B reform",
        fulltext: "Which statements do you find most convincing against reforming the 340B program?",
        keys: [
          "checkbox_against_higher_prices_pred",
          "checkbox_against_less_services_pred",
          "checkbox_against_paperwork_pred",
          "checkbox_against_rural_pred",
          "checkbox_against_threated_care_pred",
          "checkbox_against_weaken_prog_pred",

        ],
        labels: {
          "checkbox_against_higher_prices_pred": "Drug companies want reform to charge more",
          "checkbox_against_less_services_pred": "Reform risks cutting hospital-funded free services",
          "checkbox_against_paperwork_pred": "Added admin burdens could divert care resources",
          "checkbox_against_rural_pred": "Cuts could close rural hospitals",
          "checkbox_against_threated_care_pred": "Changes may reduce care for vulnerable groups",
          "checkbox_against_weaken_prog_pred": "Corporations shouldn’t undermine support for the uninsured",
        },
      schema:"client",
      },
      

      checkbox_priorities: {
        type: "categorical",
        label: "Messaging supporting reform of 340B",
        fulltext: "Which statements best describe your view of priorities for reforming the 340B program?",
        keys: [
            "checkbox_low_income_pred",
          "checkbox_restore_mission_pred",
          "checkbox_boost_profits_pred",
          "checkbox_common_sense_pred",
          "checkbox_cut_waste_pred",
          "checkbox_reform_serve_pred",
        ],
        labels: {
            "checkbox_boost_profits_pred": "Some hospitals misuse 340B to boost profits",
            "checkbox_common_sense_pred": "Drug discounts should have clear rules",
            "checkbox_cut_waste_pred": "Reform can cut waste and misuse",
            "checkbox_low_income_pred": "Ensure discounts reach low-income patients",
            "checkbox_reform_serve_pred": "Refocus 340B on intended communities",
            "checkbox_restore_mission_pred": "Restore 340B’s original mission",
          },
      schema:"client"
      },

      healthcare_concern: {
        type: "categorical",
        label: "Concerns about the U.S. healthcare system",
        fulltext:
          "Which of the following would you say is your greatest concern with regard to the U.S. healthcare system? Please select up to three.",
        keys: [
          "healthcare_concern_prescr_pred",
          "healthcare_concern_costInsurance_pred",
          "healthcare_concern_rural_access_pred",
          "healthcare_concern_coverInsurance_pred",
          "healthcare_concern_hospitalFees_pred",
          "healthcare_concern_waste_pred",
          "healthcare_concern_profit_pred",
          "healthcare_concern_waitTimes_pred",
        ],
        labels: {
          "healthcare_concern_prescr_pred": "The cost of prescription drugs",
          "healthcare_concern_costInsurance_pred": "The cost of health insurance",
          "healthcare_concern_rural_access_pred": "Lack of access in rural areas",
          "healthcare_concern_coverInsurance_pred": "Insurance not covering enough care",
          "healthcare_concern_hospitalFees_pred": "Hospitals charging too much",
          "healthcare_concern_waste_pred": "Waste and inefficiencies in the system",
          "healthcare_concern_profit_pred": "Profit driving decisions instead of patients",
          "healthcare_concern_waitTimes_pred": "Long wait times to get care",
        },
      schema:"client",
      },
      
      availability_prescription: {
        type: "likert",
        label: "Concern about prescription drug availability",
        fulltext: "How concerned are you about the availability of prescription drugs?",
        keys: [
          "availability_prescription_not_atall_concerned_pred",
          "availability_prescription_not_too_concerned_pred",
          "availability_prescription_some_concerned_pred",
          "model_availability_prescription_v_concerned_pred",
        ],
        labels: {
          "availability_prescription_not_atall_concerned_pred": "Not at all concerned",
          "availability_prescription_not_too_concerned_pred": "Not too concerned",
          "availability_prescription_some_concerned_pred": "Somewhat concerned",
          "model_availability_prescription_v_concerned_pred": "Very concerned",
        },
        colors: {
            "availability_prescription_not_atall_concerned_pred": "#2E7D32",
            "availability_prescription_not_too_concerned_pred": "#81C784",
            "availability_prescription_some_concerned_pred": "#E57373",
            "model_availability_prescription_v_concerned_pred": "#C62828",
          },

          polarity: {

            pos: "availability_prescription_not_too_concerned_pred",
            neu: "availability_prescription_some_concerned_pred",
            neg: "model_availability_prescription_v_concerned_pred"
            },
      schema:"client"
      },
      
      // === COST CONCERN ===
      cost_prescription: {
        type: "likert",
        label: "Concern about prescription drug cost",
        fulltext: "How concerned are you about the cost of prescription drugs?",
        keys: [
          "cost_prescription_not_atall_concerned_pred",
          "cost_prescription_not_too_concerned_pred",
          "cost_prescription_some_concerned_pred",
          "cost_prescription_v_concerned_pred",
        ],
        labels: {
          "cost_prescription_not_atall_concerned_pred": "Not at all concerned",
          "cost_prescription_not_too_concerned_pred": "Not too concerned",
          "cost_prescription_some_concerned_pred": "Somewhat concerned",
          "cost_prescription_v_concerned_pred": "Very concerned",
        },

        polarity: {

            pos: "cost_prescription_not_too_concerned_pred",
            neu: "cost_prescription_some_concerned_pred",
            neg: "cost_prescription_v_concerned_pred"
            }
      },
  
      // === HEALTHCARE REFORM ===
      healthcare_reform: {
        type: "likert",
        label: "View of U.S. healthcare system reform",
        fulltext: "How well do you think the U.S. healthcare system is currently working, or does it need reform?",
        keys: [
          "healthcare_reform_pred",
          "healthcare_minor_pred",
          "healthcare_well_pred",
          "healthcare_dk_pred",
        ],
        labels: {
          "healthcare_reform_pred": "Needs major reform",
          "healthcare_minor_pred": "Needs minor reform",
          "healthcare_well_pred": "Working well as is",
          "healthcare_dk_pred": "Don’t know / unsure",
        },
        polarity: {

            pos: "healthcare_well_pred",
            neu: "healthcare_minor_pred",
            neg: "healthcare_reform_pred"
            },
      schema:"client"

      },
  
      // === HEALTHCARE TRUST ===
      healthcare_trust: {
        type: "likert",
        label: "Trust in healthcare system",
        fulltext: "How much do you trust or distrust the U.S. healthcare system overall?",
        keys: [
          "healthcare_trust_pred",
          "healthcare_trust_neither_pred",
          "healthcare_distrust_pred",
        ],
        labels: {
          "healthcare_trust_pred": "Trust",
          "healthcare_trust_neither_pred": "Neither / neutral",
          "healthcare_distrust_pred": "Distrust",
        },
        polarity: {
          pos: "healthcare_trust_pred",
          neu: "healthcare_trust_neither_pred",
          neg: "healthcare_distrust_pred",
        },
      schema:"client"
      },
  
      // === TRUST INSTITUTIONS ===
      trust_institutions: {
        type: "categorical",
        label: "Trust in institutions",
        fulltext: "How much trust do you have in each of the following institutions when it comes to healthcare issues?",
        keys: [
          "trust_docs_pred",
          "trust_hospitals_pred",
          "trust_stategov_pred",
          "trust_fedgov_pred",
          "trust_pharmaorgs_pred",
          "trust_healthInsurance_pred",
          "trust_none_pred",
          "trust_dk_pred",
        ],
        labels: {
          "trust_docs_pred": "Doctors",
          "trust_hospitals_pred": "Hospitals",
          "trust_stategov_pred": "State government",
          "trust_fedgov_pred": "Federal government",
          "trust_pharmaorgs_pred": "Pharmaceutical companies",
          "trust_healthInsurance_pred": "Health insurance companies",
          "trust_none_pred": "None of these",
          "trust_dk_pred": "Don’t know",
        },
      schema:"client"
      },
  
      // === OVERSIGHT ===
      oversight: {
        type: "categorical",
        label: "Preferred oversight strength",
        fulltext: "Do you think there should be stronger or weaker oversight of how 340B funds are used?",
        keys: [
          "oversight_stronger_pred",
          "oversight_expansion_pred",
          "oversight_neutral_pred",
        ],
        labels: {
          "oversight_stronger_pred": "Stronger oversight",
          "oversight_expansion_pred": "Expanded program with similar oversight",
          "oversight_neutral_pred": "Keep oversight as is / not sure",
        },
      schema:"client"

        
      },
  
      // === PRINCIPLES ===
      principals: {
        type: "categorical",
        label: "Program’s main priorities",
        fulltext: "What should be the main priorities of the 340B program?",
        keys: [
          "principals_communities_pred",
          "principals_discounts_pred",
          "principals_dk_pred",
          "principals_low_pred",
          "principals_simple_pred",
        ],
        labels: {
          "principals_communities_pred": "Support communities in need",
          "principals_discounts_pred": "Ensure patient drug discounts",
          "principals_dk_pred": "Don’t know / unsure",
          "principals_low_pred": "Lower administrative burden",
          "principals_simple_pred": "Simplify program rules",
        },
      schema:"client",
      }
    };
  
    return { groupsById };
}

// Tab-as-config default export
export default {
  tab: "phrma",
  label: "PhRMA",
  get metrics() { return getPharmaConfig().groupsById; },
};


